// extracted by mini-css-extract-plugin
module.exports = {"Splash":"styles-module--Splash--1raZU","Splash__title":"styles-module--Splash__title--2zd0u","Splash__download":"styles-module--Splash__download--4Fg5K"};